/**
 * Calidad de código: lo común a las animaciones del módulo. Norman pidió
 * gráficas, anillos y cifras con movimiento, pero con criterio: entradas
 * breves (≤ 700 ms en las gráficas, ≤ 600 ms en anillos y cifras), nada que
 * se repita en cada interacción y nada si quien mira pidió menos movimiento
 * (prefers-reduced-motion).
 */

/** Duración de la entrada de las gráficas, en milisegundos. */
export const MS_GRAFICA = 700;

/** Duración del conteo ascendente y del llenado de los anillos. */
export const MS_CIFRA = 600;

/** true si el sistema pide reducir el movimiento (o no hay matchMedia, p. ej. en pruebas). */
export function menosMovimiento(): boolean {
  if (typeof globalThis.matchMedia !== "function") {
    return true;
  }
  return globalThis.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** easeOutQuart: arranca rápido y frena suave (la misma curva que las gráficas). */
export function suaviza(t: number): number {
  const u = 1 - Math.min(1, Math.max(0, t));
  return 1 - u * u * u * u;
}

/**
 * Corre `pinta(valor)` desde `desde` hasta `hasta` durante `ms` con
 * requestAnimationFrame, y una última vez con `hasta` exacto. Con menos
 * movimiento pinta el final de inmediato. Devuelve una función que cancela.
 */
export function cuenta(desde: number, hasta: number, ms: number, pinta: (v: number) => void): () => void {
  if (menosMovimiento() || ms <= 0 || desde === hasta || typeof globalThis.requestAnimationFrame !== "function") {
    pinta(hasta);
    return () => undefined;
  }
  let cuadro = 0;
  const inicio = performance.now();
  const paso = (ahora: number): void => {
    const t = (ahora - inicio) / ms;
    if (t >= 1) {
      pinta(hasta);
      return;
    }
    pinta(desde + (hasta - desde) * suaviza(t));
    cuadro = globalThis.requestAnimationFrame(paso);
  };
  cuadro = globalThis.requestAnimationFrame(paso);
  return () => globalThis.cancelAnimationFrame(cuadro);
}
